import { logImpression } from '@office-start/telemetry-service';
export function logFirstRunImpression() {
    logImpression({
        eventName: 'First_Run_Impression',
        area: 'FirstRun',
    });
}
//# sourceMappingURL=logFirstRunImpression.js.map